import cx from 'classnames'

import { useThemeContext } from '../../theme/useThemeContext'

type Props = {
  images: {
    light: string
    dark?: string
  }
  classNames?: string
}

export const Logo = ({ images, classNames }: Props) => {
  const { isDarkMode } = useThemeContext()

  return (
    <img
      src={isDarkMode && images.dark ? images.dark : images.light}
      className={cx(
        'h-7 p-1 rounded-md',
        !images.dark && 'dark:bg-slate-300', // Ensure visibility on dark mode when there is no custom dark image
        classNames,
      )}
      alt=""
    />
  )
}
